// @ts-ignore
import { useInView } from "react-intersection-observer";

import AccountCreation from "@/components/signup/account-creation";
import { JPDOverlayTemplate } from "@/components/signup/layouts";
import { usePremiumIntent, useStandardIntent } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForThreeCreatorsText,
    FreeToGetStartedText,
    Headings,
    InputSubmitButton,
    JPDGetStartedHeading,
    JPDGetStartedText
} from "../../components";

import {
    FreeSubheading,
    StandardSubheading
} from "./components/free-subheading";

export const LoggedOutJpd = () => {
    const { ref } = useInView();
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();

    if (isStandard || isPremium) {
        return (
            <div ref={ref}>
                <LoggedOutJpdStandardPremium />
            </div>
        );
    }

    return (
        <div ref={ref}>
            <LoggedOutJpdFree />
        </div>
    );
};

const LoggedOutJpdFree = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <JPDOverlayTemplate size="sm">
            {team26VisualUpdates ? (
                <Headings
                    main={<JPDGetStartedText />}
                    sub={<FreeForThreeCreatorsText />}
                />
            ) : (
                <>
                    <JPDGetStartedHeading />
                    <FreeSubheading />
                </>
            )}
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </JPDOverlayTemplate>
    );
};

const LoggedOutJpdStandardPremium = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <JPDOverlayTemplate size="sm">
            {team26VisualUpdates ? (
                <Headings
                    main={<JPDGetStartedText />}
                    sub={<FreeToGetStartedText />}
                />
            ) : (
                <>
                    <JPDGetStartedHeading />
                    <StandardSubheading />
                </>
            )}
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </JPDOverlayTemplate>
    );
};
